import { Area } from '../class/export';
import { history } from '../utils/export';
import { SELECT_AREA, SELECT_TOOL_DRAWING_AREA, UPDATE_DRAWING_AREA, END_DRAWING_AREA, BEGIN_DRAGGING_AREA, UPDATE_DRAGGING_AREA, END_DRAGGING_AREA } from '../constants';

export default function (state, action) {
  switch (action.type) {
    case SELECT_AREA:
      return Area.select(state, action.layerID, action.areaID).updatedState;

    case SELECT_TOOL_DRAWING_AREA:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Area.selectToolDrawingArea(state, action.sceneComponentType).updatedState;

    case UPDATE_DRAWING_AREA:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Area.updateDrawingArea(state, action.layerID, action.x, action.y).updatedState;

    case END_DRAWING_AREA:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Area.endDrawingArea(state, action.layerID, action.x, action.y).updatedState;

    case BEGIN_DRAGGING_AREA:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Area.beginDraggingArea(state, action.layerID, action.areaID, action.x, action.y).updatedState;

    case UPDATE_DRAGGING_AREA:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Area.updateDraggingArea(state, action.x, action.y).updatedState;

    case END_DRAGGING_AREA:
      state = state.merge({ sceneHistory: history.historyPush(state.sceneHistory, state.scene) });
      return Area.endDraggingArea(state, action.layerID, action.areaID, action.x, action.y).updatedState;

    default:
      return state;
  }
}